import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Form, List, Card, Button, Radio, Checkbox, Select,
  Carousel, Typography,
} from 'antd';
import _ from 'lodash'
import './styles.module.scss';
import AppHelper from 'libs/AppHelper';
import {API_HOST}  from '../../configs/env';
import whttp    from '../../libs/whttp';
import WJSON from 'libs/wjson';
const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL')

// 前端頁面
export default class WidgetWine extends Component {
  state = {
    query:{
      a: null,
      t: null,
      id:null
    },
    cityid : null,

  }
  componentDidMount() {
    const query = AppHelper.getHashParamaters()
    const cacheQuery = WJSON.decode(localStorage.getItem('c4-map-query')) || {a:null,t:null,id:null}
    
    if (!query.a && cacheQuery.a) {
      query.a = cacheQuery.a
    }
    console.log('componentDidMount', query, cacheQuery)
    this.setState({ query })
  }

  render() { 
    
    return (
      <Fragment>
        <div class="prohibit-minors-bar"><strong>禁止酒駕未滿十八歲禁止飲酒</strong></div>
      </Fragment>
      
    )
  }
}

// 編輯器
export class WidgetWineEditor extends Component {
  render() {
    return (
      <div className="vu-blocks-editor">
        <div class="components-placeholder__label">
          <span class="block-editor-block-icon"><div class="dashicons dashicons-cloud" /></span>
          酒標元件
        </div>
      </div>
    )
  }
}  


// WEBPACK FOOTER //
// ./src/blocks/widget/widget-wine.js